// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */

import { SearchFilters } from "@outschool/gql-backend-generated";
import { SearchListingsQuery } from "@outschool/gql-frontend-generated";
import { createDayjs, dayjs } from "@outschool/time";
import ldKeys from "lodash/keys";
import ldOrderBy from "lodash/orderBy";

export type ListingsProp = {
  listings: SearchListingsQuery["searchListings"]["listings"];
  tracking?: {
    startIndex?: number;
    filters?: SearchFilters;
    searchUid?: string;
    group?: string;
    numPopular?: number;
  };
  isListSelected?: boolean;
  hideHeart?: boolean;
  disabled?: boolean;
  showCredits?: boolean;
};

function canonicalJson(filters: { [k: string]: any }): string {
  const fields = ldOrderBy(ldKeys(filters))
    .filter(k => !!filters[k])
    .map(k => `"${k}":${JSON.stringify(filters[k])}`);
  return `{${fields.join(",")}}`;
}

export function uniqueIdFromFilters(
  name: string,
  filters?: SearchFilters
): string {
  return `${name}:${canonicalJson(filters ?? {})}`;
}

export const FILTER_FORMAT = "YYYY-MM-DD";
export const parseDate = (s?: dayjs.Dayjs) => {
  const parsed = createDayjs(s, FILTER_FORMAT, true);
  return parsed.isValid() ? parsed.toDate() : undefined;
};
